import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of ticket types based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(identifier) {
  return function (page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
    return baseIndex('ticket_types/'+identifier, page, itemPerPage, search, order, scheme);
  }
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single ticket type based on his ID
 *
 * @param id the of the ticket type requested
 */
export function getFromId(identifier) {
  return function (id) {
    return baseGetFromId('ticket_types/'+identifier, id);
  }
}

/**
 * Get a single product based on his ID
 *
 * @param id the of the product requested
 */
export function getIdentificationDataFromId(identifier) {
  return function (id) {
    return baseGetFromId('ticket_types/'+identifier, id, 'id');
  }
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single ticket type based on his ID
 *
 * @param id the of the ticket type requested
 * @param data the new data of the ticket type
 */
export function editFromId(identifier) {
  return function (id, data) {
    return baseEditFromId('ticket_types/'+identifier, id, data);
  }
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new ticket type
 *
 * @param data the new data of the partner
 */
export function newItem(identifier) {
  return function (data) {
    return baseNewItem('ticket_types/'+identifier, data);
  }
}


/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get the complete list of ticket types based on a pagination system
 */
export function fetchTicketTypes(identifier) {
  return function (){
    return baseIndex('ticket_types/'+identifier, 1, 0);
  }
}
